module.exports = __webpack_public_path__ + "img/arrowNextIcon.c513d90f.svg";